module.exports = require('./bootstrap-datetimepicker/moment.min.js');
